<div [class]="organisation$ | async">
  @if (loaded()) {
<app-menu class="app-top mat-typography">
  <eas-errors></eas-errors>
  <router-outlet></router-outlet>

  <mat-card appearance="outlined" id="app-footer">
    <mat-card-content>
      <app-version-information></app-version-information>
      <router-outlet name="footer"></router-outlet>
    </mat-card-content>
  </mat-card>
</app-menu>
}
</div>